<arm-dialog (onCancel)="cancel()"
            (onSubmit)="ok()"
            [title]="'Confirmation'">
    <div mat-dialog-content class="content">
        {{data?.message}}
    </div>
</arm-dialog>
